import React from 'react';
import { motion } from 'framer-motion';
import { CloudRain, Zap } from 'lucide-react';
export function TrianguloNoche() {
  const steps = [{
    step: 'Cada mañana',
    action: 'Abres el Método. 5 minutos',
    result: 'Tu mente sale de la espiral del miedo'
  }, {
    step: 'Reflexión corta',
    action: 'Honesta, sin frases vacías',
    result: 'Tu corazón se siente visto y comprendido'
  }, {
    step: 'Una verdad que ancla',
    action: 'Directa, aplicada a tu dolor real',
    result: 'Tu interior tiene algo concreto donde sostenerse'
  }, {
    step: 'Pregunta honesta',
    action: 'Sin respuestas correctas',
    result: 'Empiezas a procesar lo que no has podido decir'
  }, {
    step: 'Lo repites 40 veces',
    action: 'Sin presión, sin perfección',
    result: 'La sabiduría construye refugio desde adentro'
  }];
  return <section className="py-8 md:py-14 px-4 md:px-6 relative overflow-hidden" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-493">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[var(--accent)] opacity-[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-494" />

      <div className="max-w-[720px] mx-auto relative z-10" data-id="element-495">
        <div className="text-center mb-6 md:mb-10" data-id="element-496">
          <p className="text-[var(--accent)] text-xs font-bold tracking-widest uppercase mb-2" data-id="element-497">
            El Mecanismo Único
          </p>
          <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] mb-2 md:mb-4" data-id="element-498">
            La fe no se recupera con un impacto.{' '}
            <span className="text-[var(--text-muted)] italic" data-id="element-499">
              Se recupera por goteo.
            </span>
          </h2>
          <p className="text-[var(--text-muted)] text-sm md:text-base max-w-lg mx-auto" data-id="element-500">
            La sanación profunda no llega de golpe. Llega gota a gota, mañana
            tras mañana.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-3 md:gap-6 items-center mb-6 md:mb-10" data-id="element-501">
          <div className="bg-[var(--bg-elevated)] p-4 md:p-6 rounded-lg border border-[var(--border-subtle)] opacity-70" data-id="element-502">
            <div className="flex items-center gap-2 mb-2 text-[var(--text-muted)]" data-id="element-503">
              <Zap className="w-4 h-4" data-id="element-504" />
              <h3 className="font-bold uppercase tracking-wide text-xs" data-id="element-505">
                El Relámpago
              </h3>
            </div>
            <p className="text-xs md:text-sm leading-relaxed text-[var(--text-muted)]" data-id="element-506">
              Esperar una conversión repentina solo prolonga el sufrimiento.
            </p>
          </div>

          <div className="bg-[var(--bg-card)] p-4 md:p-6 rounded-lg border border-[var(--accent)]/25 shadow-sm relative overflow-hidden" data-id="element-507">
            <div className="absolute top-0 left-0 w-1 h-full bg-[var(--accent)]" data-id="element-508"></div>
            <div className="flex items-center gap-2 mb-2 text-[var(--accent)]" data-id="element-509">
              <CloudRain className="w-4 h-4" data-id="element-510" />
              <h3 className="font-bold uppercase tracking-wide text-xs" data-id="element-511">
                La Lluvia Suave
              </h3>
            </div>
            <p className="text-[var(--text-primary)] text-xs md:text-sm leading-relaxed font-medium" data-id="element-512">
              Pequeñas dosis de verdad, 40 mañanas seguidas, empapando la tierra
              seca de tu corazón.
            </p>
          </div>
        </div>

        {/* The mechanism */}
        <div className="bg-[var(--bg-card)] rounded-xl border border-[var(--accent)]/20 p-4 md:p-6 mb-5 md:mb-8" data-id="element-513">
          <h3 className="text-lg md:text-xl font-serif text-[var(--text-heading)] text-center mb-1" data-id="element-514">
            ⚡ El Micro-Encuentro de 40 Días
          </h3>
          <p className="text-center text-[var(--text-muted)] text-xs mb-4 italic" data-id="element-515">
            Diseñado para el alma agotada que todavía tiene fe.
          </p>
          <div className="space-y-2 md:space-y-3" data-id="element-516">
            {steps.map((s, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex flex-col md:grid md:grid-cols-[auto_1fr_1fr] gap-1 md:gap-3 items-start text-xs md:text-sm border-b border-[var(--border-subtle)] pb-2 md:pb-3 last:border-0 last:pb-0" data-id="element-517">
                <span className="text-[var(--accent)] font-bold text-[10px] md:text-xs uppercase tracking-wide md:w-24" data-id="element-518">
                  {s.step}
                </span>
                <span className="text-[var(--text-muted)]" data-id="element-519">{s.action}</span>
                <span className="text-[var(--text-primary)] font-medium" data-id="element-520">
                  {s.result}
                </span>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center space-y-2 md:space-y-3" data-id="element-521">
          <p className="text-base md:text-lg text-[var(--text-muted)] max-w-xl mx-auto" data-id="element-522">
            Solo necesitas{' '}
            <span className="text-[var(--accent)] font-bold" data-id="element-523">
              5 minutos cada mañana
            </span>
            .
          </p>
          <p className="text-[var(--text-primary)] italic font-serif text-lg md:text-xl" data-id="element-524">
            "Así es como el corazón roto vuelve a latir."
          </p>
        </div>
      </div>
    </section>;
}